import React from "react";
import image_1 from "../../images/smart-homes/Picture3-1.webp";

const smartHomeSystem = [
  {
    id: 1,
    content: "Lighting Control",
  },
  {
    id: 2,
    content: "Air Condition Control",
  },
  {
    id: 3,
    content: "Curtain Control",
  },
  {
    id: 4,
    content: "Gate Control",
  },
  {
    id: 5,
    content: "Smart Motion Sensor",
  },
  {
    id: 6,
    content: "Night Light Panel",
  },
  {
    id: 7,
    content: "Carbon Detector",
  },
];

const SmartHomeSystem = () => {
  return (
    <section className="smart-home-system pt-7 pb-7" id="smart-home-system">
      <div className="ms-13 me-13">
        <div className="row">
          <div className="col-lg-6 col-xl-6 my-auto order-1 order-lg-0 pb-5 pb-lg-0">
            <div className="">
              <h1 className="plex-sans fs-56 lh-64 pb-5">
                Smart Home <span className="text-orange-ryb">SYSTEM</span>
              </h1>
              {smartHomeSystem.map((data, index) => (
                <div className="row mb-lg-4" key={data?.id}>
                  <h2
                    className="col-2 text-24 gilroy-bold bg-american-yellow text-center me-4 card-design-2"
                    style={{
                      height: "40px",
                      width: "40px",
                      borderRadius: "50%",
                      lineHeight: "40px",
                    }}
                  >
                    {index + 1}
                  </h2>
                  <div className="col-10 my-auto">
                    <h3 className="fs-18 gilroy-bold">{data.content}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="col-lg-6 col-xl-6 order-0 order-lg-1 pb-5 pb-lg-0 my-auto">
            <img
              src={image_1}
              loading="lazy"
              className="img-fluid rounded"
              alt=""
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SmartHomeSystem;
